import { Tabs } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Background } from './configPartials/Background';
import { Borders } from './configPartials/Borders';
import { Corners } from './configPartials/Corners';
import { Layout } from './configPartials/Layout';
import { Position } from './configPartials/Position';
import { Shadow } from './configPartials/Shadow';
import { ConfigTitleBase } from '../../../../../components/studio/ConfigTitleBase/ConfigTitleBase';
import { WidgetConfig } from '../../../../../components/studio/WidgetConfig/WidgetConfig';
import { TooltipProps } from '../Tooltip.types';

export type TooltipConfigProps = {
  styles: TooltipProps;
  onUpdateStyle: (styleToUpdate: TooltipProps) => void;
  onRemoveStyle: (styleKey: keyof TooltipProps) => void;
};

export function TooltipConfig(props: TooltipConfigProps) {
  const { t } = useTranslation('components.theme.settings');

  return (
    <WidgetConfig customTitle={<ConfigTitleBase title={t('tooltip.title')} />} tabs={['appearance']}>
      <Tabs.Panel key="appearance" value="appearance">
        <Background {...props} />
        <Corners {...props} />
        <Borders {...props} />
        <Shadow {...props} />
        <Position {...props} />
        <Layout {...props} />
      </Tabs.Panel>
    </WidgetConfig>
  );
}
